export const SEX_TYPES = {
  FEMALE: 'female',
  MALE: 'male'
};

export const mailUrl = 'admin@treuhand-suche.ch';